import PropTypes from 'prop-types';
import { AvlMaskedInput } from '../MaskedInput/AvlMaskedInput';

export function AvlPhoneMaskedInput({ label = '', value, onChange, isDisabled, error, helperText, mask, placeholder, ...props }) {
    const handleChange = (event) => {
        const newValue = event.target.value;
        onChange?.(newValue);
    };

    return (
        <AvlMaskedInput
            label={label}
            value={value}
            onChange={handleChange}
            isDisabled={isDisabled}
            error={error}
            helperText={helperText}
            mask={mask}
            placeholder={placeholder}
            {...props}
        />
    );
}

AvlPhoneMaskedInput.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    isDisabled: PropTypes.bool,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    className: PropTypes.string,
    required: PropTypes.bool,
    name: PropTypes.string,
    mask: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
}; 
